/**
 * Metabase report IDs differ across environments (the Dev/UAT/Prod Metabase
 * instances were seeded independently, so the same report can have a
 * different numeric ID in each environment).
 *
 * Each report component still hardcodes a single `reportId` (its
 * Development ID). CommonComponent uses this table to remap that ID to the
 * correct one for the running environment (REACT_APP_ENV), keyed by the
 * report's `reportName`.
 *
 * If a report is not listed here, or has no entry for the current
 * environment, CommonComponent falls back to the `reportId` passed in from
 * the report component.
 *
 * TODO: fill in the real `uatId` / `prodId` values once known. Until then
 * they default to the same value as `devId`.
 */
export type MetabaseReportEnvConfig = {
    reportName: string
    devId: number
    uatId: number
    prodId: number
}

export const METABASE_REPORT_ENV_CONFIG: MetabaseReportEnvConfig[] = [
    { reportName: "Booking Report", devId: 74, uatId: 253, prodId: 253 },
    { reportName: "Daily Recap Report", devId: 73, uatId: 256, prodId: 256 },
    { reportName: "Manifest Charge Report", devId: 63, uatId: 227, prodId: 227 },
    { reportName: "DPS Pending Report", devId: 76, uatId: 76, prodId: 76 },
    { reportName: "DPS Todays Released Report", devId: 77, uatId: 77, prodId: 77 },
    { reportName: "Exception Report", devId: 97, uatId: 97, prodId: 97 },
    { reportName: "Fuel Management Report", devId: 19, uatId: 19, prodId: 19 },
    { reportName: "Picking To Oracle Report", devId: 21, uatId: 21, prodId: 21 },
    { reportName: "Driver Tracking History Report", devId: 143, uatId: 254, prodId: 254 },
    { reportName: "Trip Plan Status Report", devId: 26, uatId: 33, prodId: 33 },
    { reportName: "Box Utilization Report", devId: 148, uatId: 148, prodId: 148 },
    { reportName: "Trip Pallet Utilization Report", devId: 165, uatId: 242, prodId: 242 },
    { reportName: "Customer Shipper Coordinates Report", devId: 161, uatId: 240, prodId: 240 },
    { reportName: "Customer Consignee Coordinates", devId: 159, uatId: 241, prodId: 241 },
    { reportName: "Daily Scan Report", devId: 149, uatId: 237, prodId: 237 },
    { reportName: "First Mile Report", devId: 116, uatId: 229, prodId: 229 },
    { reportName: "Middle Mile Report", devId: 117, uatId: 230, prodId: 230 },
    { reportName: "Last Mile Report", devId: 118, uatId: 231, prodId: 231 },
    { reportName: "In Transit Pending Report", devId: 115, uatId: 233, prodId: 233 },
    { reportName: "Fleet Utilization Report", devId: 151, uatId: 238, prodId: 238 },
    { reportName: "FTL Ideal Vehicle Report", devId: 150, uatId: 236, prodId: 236 },
    { reportName: "Vehicle Utilization Report", devId: 153, uatId: 239, prodId: 239 },
    { reportName: "Courier Trip Stops Report", devId: 206, uatId: 244, prodId: 244 },
    { reportName: "Out-of-Location Shipment Scan Report", devId: 203, uatId: 252, prodId: 252 },
    { reportName: "Pickup/Delivery scan at Hub Report", devId: 202, uatId: 249, prodId: 249 },
    { reportName: "Shipper Consignee Waiting Time Report", devId: 208, uatId: 247, prodId: 247 },
    { reportName: "Suspicious Scan Report", devId: 204, uatId: 251, prodId: 251 },
    { reportName: "Vehicle Login and Logout Data", devId: 209, uatId: 246, prodId: 246 },
    { reportName: "Idle Severity Report", devId: 207, uatId: 245, prodId: 245 },
    { reportName: "Absence of Short Address / Incomplete Address Report", devId: 193, uatId: 243, prodId: 243 },
    { reportName: "GPI FSC Impact Report", devId: 259, uatId: 259, prodId: 259 },
    { reportName: "Handover Sheet Report", devId: 273, uatId: 273, prodId: 273 },
    { reportName: "Manifest Confirmation Pending Report", devId: 260, uatId: 260, prodId: 260 },
    { reportName: "POD Meta Report", devId: 277, uatId: 277, prodId: 277 },
    { reportName: "POD Agreement Report", devId: 284, uatId: 284, prodId: 284 },
];
